import { useState } from 'react';

import {
  NavBar,
  Box,
  Text,
  IconButton,
  MenuIcon,
  Grid,
  FlipCameraAndroidIcon,
  PhotoLibraryIcon,
  DashboardIcon,
  Hidden,
} from '@components/common';
import { ConnectWalletButton } from '../ConnectWalletButton';

interface AppMenuProps {
  title: string;
  walletAddress?: string;
  onWalletClick?: () => void;
}

export const AppMenu = ({
  title,
  walletAddress,
  onWalletClick,
}: AppMenuProps) => {
  const [open, setOpen] = useState(false);

  return (
    <NavBar
      open={open}
      items={[
        {
          Icon: DashboardIcon,
          name: 'Dashboard',
          link: '/',
        },
        {
          Icon: FlipCameraAndroidIcon,
          name: 'Portal',
          link: '/portal',
        },
        {
          Icon: PhotoLibraryIcon,
          name: 'Collection',
          link: '/collection',
        },
      ]}
      handleClose={() => setOpen(false)}
      Logo={
        <Text
          fontFamily="Caveat"
          variant="h4"
          textAlign="center"
          fontWeight="bold"
          fontStyle="normal"
          pl={54}
          pr={22}
        >
          {title}
        </Text>
      }
    >
      <Grid
        container
        justify="space-between"
        alignItems="center"
        spacing={3}
        wrap="nowrap"
      >
        <Grid item xs>
          <IconButton
            edge="start"
            aria-label="menu"
            onClick={() => setOpen(true)}
          >
            <MenuIcon />
          </IconButton>
        </Grid>
        <Hidden xsDown>
          <Grid item xs>
            <Text
              fontFamily="Caveat"
              variant="h4"
              textAlign="center"
              fontWeight="bold"
              fontStyle="normal"
            >
              {title}
            </Text>
          </Grid>
        </Hidden>

        <Grid item xs={12} sm={4} lg={4}>
          <Box display="flex" justifyContent="flex-end">
            <ConnectWalletButton
              address={walletAddress}
              onClick={() => onWalletClick && onWalletClick()}
            />
          </Box>
        </Grid>
      </Grid>
    </NavBar>
  );
};
